import { createFileRoute } from '@tanstack/react-router'
import {
  SalesOrdersSection,
  salesOrdersLoader,
  validateSalesOrdersSearch,
  type SalesOrdersSearchParams,
} from '@spcc/domains/sales-orders'

export const Route = createFileRoute('/sales-orders')({
  validateSearch: (search): SalesOrdersSearchParams => validateSalesOrdersSearch(search),
  // No loaderDeps: loader only runs on route navigation, not on URL param changes
  // (prevents pagination replaceState calls from re-triggering the loader and resetting page)
  loader: async ({ context }) => salesOrdersLoader({ context }),
  component: SalesOrdersPage,
})

function SalesOrdersPage() {
  return <SalesOrdersSection />
}
